'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
exports['default'] = SwiperBase;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _pubsub = require('pubsub');

var _pubsub2 = _interopRequireDefault(_pubsub);

var _gsap = require('gsap');

var _gsap2 = _interopRequireDefault(_gsap);

var _swiper = require('swiper');

var _swiper2 = _interopRequireDefault(_swiper);

function SwiperBase() {

	// Swiper.use([Autoplay, EffectFade]);
	function checkArrows(item) {
		if (item.querySelector('.swiper-button-next').classList.contains('swiper-button-disabled') && item.querySelector('.swiper-button-prev').classList.contains('swiper-button-disabled')) {
			item.querySelector('.paragraphe-slider-nav').style.display = 'none';
		} else {
			item.querySelector('.paragraphe-slider-nav').style.display = 'flex';
		}
		console.log(item.querySelectorAll('.swiper-slide').length);
		if (item.querySelectorAll('.swiper-slide').length < 2) {
			item.querySelector('.paragraphe-slider-nav').style.display = 'none';
		}
	}

	var _swipers = document.querySelectorAll('.swiper-base');
	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = _swipers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var el = _step.value;

			var mySwiper = new _swiper2['default'](el, {
				// Optional parameters
				direction: 'horizontal',

				threshold: 50,
				effect: 'fade',
				speed: 2000,
				autoplay: {
					delay: 3500,
					disableOnInteraction: false,
					crossFade: true
				},

				// If we need pagination
				pagination: {
					el: '.swiper-pagination',
					clickable: true
				},
				watchOverflow: true,

				// Navigation arrows
				navigation: {
					nextEl: el.parentNode.querySelector('.swiper-button-next'),
					prevEl: el.parentNode.querySelector('.swiper-button-prev')
				}

			});

			// And if we need scrollbar
			//scrollbar: '.swiper-scrollbar',
			checkArrows(el);
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator['return']) {
				_iterator['return']();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}

	var _swipersSingleLine = document.querySelectorAll(".swiper-container.strip-swiper");

	var _iteratorNormalCompletion2 = true;
	var _didIteratorError2 = false;
	var _iteratorError2 = undefined;

	try {
		for (var _iterator2 = _swipersSingleLine[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
			var el = _step2.value;

			var mySwiper3 = new _swiper2['default'](el, {
				direction: "horizontal",
				slidesPerView: 3.5,
				spaceBetween: 30,
				watchOverflow: true,
				// Navigation arrows
				navigation: {
					nextEl: el.parentNode.querySelector('.swiper-button-next'),
					prevEl: el.parentNode.querySelector('.swiper-button-prev')
				},
				breakpoints: {
					640: {
						slidesPerView: 1.3,
						spaceBetween: 30
					}
				}
			});
			checkArrows(el);
		}
	} catch (err) {
		_didIteratorError2 = true;
		_iteratorError2 = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion2 && _iterator2['return']) {
				_iterator2['return']();
			}
		} finally {
			if (_didIteratorError2) {
				throw _iteratorError2;
			}
		}
	}

	var _swipersSlider = document.querySelectorAll('.slider-herozone, .slider');
	var _iteratorNormalCompletion3 = true;
	var _didIteratorError3 = false;
	var _iteratorError3 = undefined;

	try {
		for (var _iterator3 = _swipersSlider[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
			var el = _step3.value;

			// Swiper.use([Autoplay, EffectFade]);

			var mySwiper = new _swiper2['default'](el, {

				// Optional parameters
				direction: 'horizontal',
				speed: 2000,
				threshold: 50,
				watchOverflow: true,
				loop: true,
				effect: 'fade',
				autoplay: {
					delay: 3500,
					disableOnInteraction: false,
					crossFade: true
				}
			});
		}
	} catch (err) {
		_didIteratorError3 = true;
		_iteratorError3 = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion3 && _iterator3['return']) {
				_iterator3['return']();
			}
		} finally {
			if (_didIteratorError3) {
				throw _iteratorError3;
			}
		}
	}
}

module.exports = exports['default'];
// If we need pagination
// pagination: {
// 	el: '.swiper-pagination',
// 	clickable: true,
// },

// Navigation arrows
// navigation: {
// 	nextEl: '.swiper-button-next',
// 	prevEl: '.swiper-button-prev',
// },

// And if we need scrollbar
//scrollbar: '.swiper-scrollbar',
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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